import type { Point } from "geojson";
import type { GeoJSON, Layer, Map as LeafletMap } from "leaflet";
import type { InjectionKey } from "vue";

import type { MarkerProperties } from "@/lib/api-client";

export type { MarkerProperties };

export interface GeoMapContext {
	map: LeafletMap | null;
	baseLayer: Layer | null;
	featureGroups: {
		markers: GeoJSON<MarkerProperties, Point> | null;
	};
}

export const key = Symbol() as InjectionKey<GeoMapContext>;
